__turbopack_context__.v({
  "cont": "single-bar-chart-module-scss-module__ueD27G__cont",
  "cont-bar": "single-bar-chart-module-scss-module__ueD27G__cont-bar",
  "cont-bar-item": "single-bar-chart-module-scss-module__ueD27G__cont-bar-item",
  "cont-bar-left": "single-bar-chart-module-scss-module__ueD27G__cont-bar-left",
  "cont-bar-right": "single-bar-chart-module-scss-module__ueD27G__cont-bar-right",
  "cont-labels": "single-bar-chart-module-scss-module__ueD27G__cont-labels",
  "cont-labels-item": "single-bar-chart-module-scss-module__ueD27G__cont-labels-item",
  "cont-labels-left": "single-bar-chart-module-scss-module__ueD27G__cont-labels-left",
  "cont-labels-right": "single-bar-chart-module-scss-module__ueD27G__cont-labels-right",
  "cont-title": "single-bar-chart-module-scss-module__ueD27G__cont-title",
});
